import actions from './actions';
const initState = {
    bulkActivationFResponse: [],
    bulkActivationLoading: false,
    bulkActivationMessage: null,
    bulkActivationError: null,

}

export default function reducer(state = initState, action) {
    switch (action.type) {

        case actions.BULK_ACTIVATION:
            return {
                ...state,
                bulkActivationFResponse: [],
                bulkActivationLoading: true,
                bulkActivationMessage: null,
                bulkActivationError: null,
            };
        case actions.BULK_ACTIVATION_SUCCESS:
            return {
                ...state,
                bulkActivationLoading: false,
                bulkActivationMessage: action.payload.message,
                bulkActivationError: null,
            };
        case actions.BULK_ACTIVATION_FAILED:
            return {
                ...state,
                bulkActivationLoading: false,
                bulkActivationMessage: null,
                bulkActivationError: action.payload.error,
                bulkActivationFResponse: action.payload.data,

            };

        case actions.RESET_MESSAGE:
            return {
                ...state,
                bulkActivationFResponse: [],
                bulkActivationMessage: null,
                bulkActivationError: null,
            };



        default:
            return state;
    }
}